module.exports = __webpack_public_path__ + "assets/img/btnMore.7f09d58a.svg";